(function() {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    var fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '₹{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function renderCart(cart) {
    var title = drawer.querySelector('.cart-drawer__title');
    if (title) title.textContent = 'Shopping Cart (' + cart.item_count + ')';

    document.querySelectorAll('[data-cart-count]').forEach(function(badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? '' : 'none';
    });

    var body = drawer.querySelector('[data-cart-items]');
    var footer = drawer.querySelector('.cart-drawer__footer');

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : (item.image ? item.image : '');
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">'
        : '';

      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
        : '';

      var propsHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function(key) {
          if (key.charAt(0) !== '_' && item.properties[key]) {
            propsHtml += '<p class="cart-drawer__item-prop"><span class="cart-drawer__item-prop-key">' + key + ':</span> ' + item.properties[key] + '</p>';
          }
        });
      }

      html += '<div class="cart-drawer__item">'
        + '<a href="' + item.url + '" class="cart-drawer__item-image">' + imgHtml + '</a>'
        + '<div class="cart-drawer__item-info">'
        + '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>'
        + variantHtml
        + propsHtml
        + '<div class="cart-drawer__item-qty">'
        + '<button type="button" class="cart-drawer__qty-btn" data-cart-change="' + item.key + '" data-qty="' + Math.max(0, item.quantity - 1) + '">&minus;</button>'
        + '<span class="cart-drawer__qty-val">' + item.quantity + '</span>'
        + '<button type="button" class="cart-drawer__qty-btn" data-cart-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
        + '</div>'
        + '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>'
        + '</div>'
        + '<button type="button" class="cart-drawer__item-remove" data-cart-change="' + item.key + '" data-qty="0" aria-label="Remove">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button>'
        + '</div>';
    });

    body.innerHTML = html;

    if (footer) {
      footer.style.display = '';
      var subtotal = footer.querySelector('.cart-drawer__subtotal');
      if (subtotal) subtotal.innerHTML = '<span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span>';
    }
  }

  function fetchAndRenderCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); return cart; });
  }

  // Intercept ALL add-to-cart form submissions
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    // Clamp qty to max before reading FormData (HTML max doesn't block AJAX)
    var qtyEl = form.querySelector('[name="quantity"]');
    if (qtyEl) {
      var qtyVal = parseInt(qtyEl.value) || 1;
      var qtyMax = qtyEl.max ? parseInt(qtyEl.max) : Infinity;
      qtyEl.value = Math.min(Math.max(qtyVal, 1), qtyMax);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function(item) {
      try {
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: {
          product_id: item.product_id,
          product_title: item.product_title,
          variant_id: item.variant_id,
          variant_title: item.variant_title !== 'Default Title' ? item.variant_title : null,
          price: item.price / 100,
          quantity: item.quantity
        }}));
      } catch(err) {}
      return fetchAndRenderCart();
    })
    .then(function() { open(); })
    .catch(function(err) { console.error('Cart error:', err); })
    .finally(function() { if (submitBtn) submitBtn.disabled = false; });
  });

  // Quantity changes and removes inside the drawer
  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();

    var key = btn.getAttribute('data-cart-change');
    var qty = parseInt(btn.getAttribute('data-qty'));

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCart(cart);
      if (cart.item_count === 0) setTimeout(close, 600);
    });
  });

  // Close handlers
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function(el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Header cart icon toggle
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      fetchAndRenderCart().then(open);
    });
  });

  // Offers toggle (collapsible)
  var offersToggle = drawer.querySelector('[data-offers-toggle]');
  var offersList = drawer.querySelector('[data-offers-list]');
  if (offersToggle && offersList) {
    offersToggle.addEventListener('click', function() {
      var expanded = offersToggle.getAttribute('aria-expanded') === 'true';
      offersToggle.setAttribute('aria-expanded', !expanded);
      offersList.classList.toggle('is-open');
    });
  }

  // =============================================
  // DISCOUNT CODE SYSTEM
  // =============================================
  var discountInput = drawer.querySelector('[data-discount-input]');
  var discountApply = drawer.querySelector('[data-discount-apply]');
  var discountMsg = drawer.querySelector('[data-discount-msg]');
  var savingsEl = drawer.querySelector('[data-cart-savings]');
  var savingsAmount = drawer.querySelector('[data-cart-savings-amount]');

  // Get/set applied code from localStorage so it persists
  function getAppliedCode() {
    try { return localStorage.getItem('att_discount_code') || ''; } catch(e) { return ''; }
  }
  function setAppliedCode(code) {
    try {
      if (code) {
        localStorage.setItem('att_discount_code', code);
      } else {
        localStorage.removeItem('att_discount_code');
      }
    } catch(e) {}
  }

  function applyDiscount(code) {
    if (!code) return;
    setAppliedCode(code);
    if (discountInput) discountInput.value = code;

    // Update offer rows UI — only one at a time
    drawer.querySelectorAll('.cart-drawer__offer-row, .cart-drawer__offer').forEach(function(row) {
      row.classList.remove('is-applied');
      var btn = row.querySelector('.cart-drawer__offer-apply');
      if (btn) { btn.textContent = 'Apply'; btn.disabled = false; }
    });
    var activeBtn = drawer.querySelector('[data-offer-code="' + code + '"]');
    if (activeBtn) {
      var row = activeBtn.closest('.cart-drawer__offer-row') || activeBtn.closest('.cart-drawer__offer');
      if (row) row.classList.add('is-applied');
      activeBtn.textContent = 'Applied';
      activeBtn.disabled = true;
    }

    // Show success message
    if (discountMsg) {
      discountMsg.textContent = '"' + code + '" will be applied at checkout.';
      discountMsg.className = 'cart-drawer__discount-msg is-success';
    }
  }

  // Restore previously applied code on page load
  var savedCode = getAppliedCode();
  if (savedCode) {
    applyDiscount(savedCode);
  }

  // Get current cart subtotal in rupees from the DOM
  function getCartSubtotal() {
    var el = drawer.querySelector('[data-cart-drawer-subtotal]');
    if (!el) return 0;
    var text = el.textContent.replace(/[^0-9.]/g, '');
    return parseFloat(text) || 0;
  }

  // Keep offers section open
  function keepOffersOpen() {
    if (offersToggle && offersList) {
      offersToggle.setAttribute('aria-expanded', 'true');
      offersList.classList.add('is-open');
    }
  }

  // One-tap offer apply with minimum order validation
  drawer.addEventListener('click', function(e) {
    var offerBtn = e.target.closest('[data-offer-code]');
    if (!offerBtn) return;
    e.stopPropagation();

    var row = offerBtn.closest('[data-offer-min]');
    var minOrder = row ? parseFloat(row.getAttribute('data-offer-min')) || 0 : 0;

    if (minOrder > 0) {
      var subtotal = getCartSubtotal();
      if (subtotal < minOrder) {
        if (discountMsg) {
          discountMsg.textContent = 'Add Rs. ' + (minOrder - subtotal).toFixed(0) + ' more to use this offer (min Rs. ' + minOrder + ')';
          discountMsg.className = 'cart-drawer__discount-msg is-error';
        }
        keepOffersOpen();
        return;
      }
    }

    applyDiscount(offerBtn.getAttribute('data-offer-code'));
    keepOffersOpen();
  });

  // Manual coupon input
  if (discountApply && discountInput) {
    discountApply.addEventListener('click', function() {
      applyDiscount(discountInput.value.trim());
    });
    discountInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount(discountInput.value.trim());
      }
    });
  }

  // CHECKOUT BUTTON — the critical part.
  // Instead of linking to /checkout directly, we go through
  // /discount/CODE?redirect=/checkout which is Shopify's official
  // way to apply a discount and then redirect to checkout.
  // This sets the discount in the session cookie properly.
  drawer.addEventListener('click', function(e) {
    var checkoutLink = e.target.closest('[data-cart-checkout]');
    if (!checkoutLink) return;

    var code = getAppliedCode();
    if (code) {
      e.preventDefault();
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
    }
    // If no code applied, the default /checkout href works fine
  });

  // Expose globally
  window.cartDrawer = { open: open, close: close, refresh: fetchAndRenderCart };
})();
